import { baseApi } from 'services'

import { ChecklistGroup, PaginatedResults } from '@/types/unlock'

export const checklistGroupV2 = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    updateItemsFromTemplate: builder.mutation<
      void,
      { applicationId: string; checklistGroupId: string; avoidInvalidate?: boolean }
    >({
      query: ({ applicationId, checklistGroupId }) => ({
        url: `v2/applications/${applicationId}/checklist-groups/${checklistGroupId}/update-from-template/`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, arg) => (arg.avoidInvalidate ? null : ['ChecklistGroups']),
    }),
    completeAllItemsFromGroup: builder.mutation<
      void,
      { applicationId: string; checklistGroupId: string }
    >({
      query: ({ applicationId, checklistGroupId }) => ({
        url: `v2/applications/${applicationId}/checklist-groups/${checklistGroupId}/complete-all-group-items/`,
        method: 'POST',
      }),
      invalidatesTags: ['ChecklistGroups'],
    }),
    auditAllDoneItemsFromGroup: builder.mutation<
      void,
      { applicationId: number; checklistGroupUUID: string }
    >({
      query: ({ applicationId, checklistGroupUUID }) => ({
        url: `v2/applications/${applicationId}/checklist-groups/${checklistGroupUUID}/audit-all-group-items/`,
        method: 'POST',
      }),
      invalidatesTags: ['ChecklistGroups'],
    }),
    getChecklistGroups: builder.query<PaginatedResults<ChecklistGroup[]>, string | string[]>({
      query: (applicationUUID) => `v2/applications/${applicationUUID}/checklist-groups`,
      providesTags: ['ChecklistGroups'],
    }),
    getChecklistGroupsVisibleItems: builder.query<
      PaginatedResults<ChecklistGroup[]>,
      string | string[]
    >({
      query: (applicationUUID) =>
        `v2/applications/${applicationUUID}/checklist-groups/?task_visibility=1`,
      providesTags: ['ChecklistGroups'],
    }),
    updateChecklistGroup: builder.mutation<
      ChecklistGroup,
      { applicationUUID: string; checklistGroup: Partial<ChecklistGroup> }
    >({
      query: ({ applicationUUID, checklistGroup }) => ({
        url: `v2/applications/${applicationUUID}/checklist-groups/${checklistGroup.uuid}/`,
        method: 'PATCH',
        body: checklistGroup,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'ApplicationGuidelines',
        'ChecklistGroups',
      ],
    }),
  }),
})

export const {
  useUpdateItemsFromTemplateMutation,
  useGetChecklistGroupsQuery,
  useGetChecklistGroupsVisibleItemsQuery,
  useUpdateChecklistGroupMutation,
  useCompleteAllItemsFromGroupMutation,
  useAuditAllDoneItemsFromGroupMutation,
} = checklistGroupV2
